<svelte:options accessors/>
<script lang="ts">
    import {Cart, getCart} from "../../models/cart";
    import {onMount} from "svelte";
    import Subtotal from "./Subtotal.svelte";
    import CheckoutItem from "./CheckoutItem.svelte";
    import {getFormatter} from "../../utils";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import LinearProgress from "@smui/linear-progress";

    export let cart: Cart;
    let formatter = getFormatter();

    export let confirmed = false;
    export let urlPay: string;

    export let dialog: any = {
        open: false,
        message: ''
    }
    let order: any;
    let loading = false;
    export let dialogOrder: any = {
        open: false
    }

    onMount(() => {
        loading = true;
        getCart().then((c) => {
            cart = c;
            loading = false;
        });
    });

    $: continueLabel = confirmed ? 'Pagar' : 'Confirmar precio y disponibilidad';


    async function next() {
        if (cart.confirmed) {
            try {
                loading = true;
                //order = await cart.createOrder();
                if (order) {
                    dialogOrder.open = true;
                } else {
                    dialog.message = 'Se presento un error generando el pedido'
                    dialog.open = true;
                }
                loading = false;
            } catch (e) {
                loading = false;
                dialog.message = 'Se presento un error generando el pedido'
                dialog.open = true;
            }
        } else {
            try {
                loading = true;
                const {el} = await cart.checkPrices();
                cart = cart;
                confirmed = cart.confirmed;
                if (!cart.confirmed) {
                    dialog = {
                        open: true,
                        message: el.textContent
                    }
                }
                loading = false
            } catch (e) {
                loading = false
                dialog = {
                    open: true,
                    message: 'Se presento un error generando el pedido'
                }
            }

        }
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }
</script>
{#if cart}
    {#if loading}
        <div class="container">
            <div class="text-c loading-bar">
                <LinearProgress class="w-100" indeterminate/>
                <small>Procesando...</small>
            </div>
        </div>
    {:else}
        <div>
            <section>
                <div class="container max-w-900px mx-auto">
                    <div class="py-15">
                        {#if cart.toDelivery}
                            {#if cart.partsWithDelivery.length > 0}
                                <div>
                                    <strong class="block mb-1">Productos de envío a domicilio</strong>
                                    <div>
                                        {#each cart.partsWithDelivery as product}
                                            <CheckoutItem data="{product}"/>
                                        {/each}
                                    </div>
                                </div>
                            {/if}
                            {#if cart.accessoriesToDelivery.length > 0}
                                <div>
                                    <strong class="block mb-1">Accesorios de envío a domicilio</strong>
                                    <div>
                                        {#each cart.accessoriesToDelivery as product}
                                            <CheckoutItem data="{product}"/>
                                        {/each}
                                    </div>
                                </div>
                            {/if}
                        {/if}
                        {#if cart.partsWithoutDelivery?.length > 0}
                            <div>
                                <strong class="block mb-1">Items sin envío a domicilio</strong>
                                <div>
                                    {#each cart.partsWithoutDelivery as product}
                                        <CheckoutItem data="{product}"/>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                        {#if cart.accessoriesToInstall?.length > 0}
                            <div>
                                <strong class="block mb-1">Accesorios</strong>
                                <div>
                                    {#each cart.accessoriesToInstall as product}
                                        <CheckoutItem data="{product}"/>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                        {#if cart.services?.length > 0}
                            <div>
                                <strong class="block mb-1">Servicios</strong>
                                <div>
                                    {#each cart.services as product}
                                        <CheckoutItem data="{product}"/>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                        {#if cart.revisions?.length > 0}
                            <div>
                                <strong class="block mb-1">Revisiones</strong>
                                <div>
                                    {#each cart.revisions as product}
                                        <CheckoutItem data="{product}"/>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                        {#if cart.plans?.length > 0}
                            <div>
                                <strong class="block mb-1">Planes</strong>
                                <div>
                                    {#each cart.plans as product}
                                        <CheckoutItem data="{product}"/>
                                    {/each}
                                </div>
                            </div>
                        {/if}

                        <div>
                            {#if cart.shippingCost}
                                <div class="box-b mb-1">
                                    <strong>Costo de envío</strong>
                                    <div style="font-size: 18px">{formatter(cart.shippingCost)}</div>
                                </div>
                            {/if}
                            <div class="box-b">
                                <strong>Impuestos</strong>
                                <div style="font-size: 18px">IVA Incluído</div>
                            </div>
                        </div>
                    </div>
                    <Subtotal subtotal="{cart.subtotal}"
                              zIndex={true}
                              label="{continueLabel}"
                              on:click={()=>next()}/>
                </div>
            </section>
        </div>
    {/if}
{/if}

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>

<Dialog bind:open={dialogOrder.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        <b>A continuación serás redirigido a nuestra plataforma de pagos</b>
    </Content>
    <Actions>
        {#if order?.order_code}
            <div class="box sx-ii">
                <a href={`${urlPay}=${order.order_code}`}
                   target="_blank"
                   class="btn accent">
                    ENTENDIDO
                </a>
            </div>
        {/if}
    </Actions>
</Dialog>